<template>
  <div class="content page--unsubscribe">
    <div class="container">
      <header-logo :logo-url="globalLogoUrl" />
      <h1 v-word:layout.unsubscribe.header></h1>
      <h2 v-word:layout.unsubscribe.text></h2>
      <section class="form__section">
        <div class="form__input form__input--submit">
          <button @click="$router.push({ name: 'unsubscribe-confirmed' })"
                  v-word:layout.unsubscribe.button />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';

export default {
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
};
</script>



// WEBPACK FOOTER //
// src/pages/Unsubscribe.vue